// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { tableStyles } from "@guestsupply/App/Widgets/OrderApprovalList/OrderAwaitingApprovalListTable";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

tableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

tableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

tableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 5px;
    `,
};
tableStyles.centeringWrapper = {
    css: css`
        height: 300px;
        display: flex;
        align-items: center;
    `,
};
tableStyles.spinner = {
    css: css`
        margin: auto;
    `,
};
tableStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 8px;
        }
    `,
};
tableStyles.orderCountText = {
    ...myAccountFilterSectionStyles.orderCountText,
    css: css`
        ${xScreen("lte", "sm")} {
            margin-bottom: 8px;
        }
    `,
};
tableStyles.customerAwaitingText = {
    variant: "h1",
    as: "p",
    css: css`
        font-size: 28px;
    `,
};
